import React from 'react';
import { Button } from 'reactstrap';
import './style.css';

const WhatsNewButton = () => {
  const toggleChangelog = () => {
    try {
      // Verifica se já existe um painel aberto e VISIVEL no DOM
      const possiblePanels = [
        document.querySelector('[data-changelog-widget]'),
        document.querySelector('.changelog-widget'),
        document.querySelector('#changelog-widget'),
        document.querySelector('[class*="changelog"]'),
        document.querySelector('.changelogger-widget'),
        document.querySelector('[id*="changelog"]')
      ].filter(Boolean);

      // Verifica se painel esta visvel
      const visiblePanel = possiblePanels.find(panel => {
        const styles = window.getComputedStyle(panel);
        return styles.display !== 'none' && 
               styles.visibility !== 'hidden' && 
               styles.opacity !== '0' &&
               panel.offsetParent !== null;
      });

      // Se existe um painel visível - tenta fechar
      if (visiblePanel) {
        // Múltiplas estratégias de fechamento
        if (window.closeChangelogWidget) {
          window.closeChangelogWidget();
        } else if (window.changelog_widget_close) {
          window.changelog_widget_close();
        } else {
          // Remove o elemento diretamente
          visiblePanel.remove();
        }
        
        return;
      }
      
      // Limpa qualquer elemento fantasma que possa existir
      possiblePanels.forEach(panel => {
        if (panel && panel.parentNode) {
          panel.remove();
        }
      });
      
      // Certifica que o widget está inicializado
      if (window.initChangelogWidget) {
        window.initChangelogWidget();
      }
      
      // Abre o widget
      if (window.openChangelogWidget) {
        window.openChangelogWidget('sidepanel');
      }
    } catch (error) {
      console.error('Erro ao toggle changelog:', error);
    }
  };

  return (
    <Button className="whatsnew-btn" onClick={toggleChangelog}>
      Novidades
    </Button>
  );
};

export default WhatsNewButton;
